import { IAddFormService } from './addFormService';

export interface IAdFieldsCleaningService {
  onOwnerTypeChange(): void;
}

export const AdFieldsCleaningService = ['addFormService',
  (addFormService: IAddFormService): IAdFieldsCleaningService => {
    const cleanAllRoomsAreaForHomeowner = () => {
      /* При переключении формы на соба остается значение поля allRoomsArea
         Модерацией может быть заблокировано объявление с этим полем, если значения будут отличаться от livingArea
      */
      const { ad } = addFormService;

      const isByHomeowner = ad.isByHomeowner;
      const allRoomsArea = ad.allRoomsArea;

      if (isByHomeowner && allRoomsArea) {
        delete ad.allRoomsArea;
      }
    };

    const onOwnerTypeChange = () => {
      const { ad } = addFormService;

      if (ad) {
        cleanAllRoomsAreaForHomeowner();
      }
    };

    const service = {
      onOwnerTypeChange,
    };

    return service;
}];
